var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4364 9.69911V5.0475C11.4364 2.26433 9.17211 0 6.38889 0C3.60567 0 1.34139 2.26433 1.34139 5.0475V9.69911C0.501111 10.7808 0 12.1385 0 13.6111C0 17.1339 2.86606 20 6.38889 20C9.91172 20 12.7778 17.1339 12.7778 13.6111C12.7778 12.1385 12.2767 10.7808 11.4364 9.69911ZM2.4525 5.0475C2.4525 2.87694 4.21833 1.11111 6.38889 1.11111C8.55944 1.11111 10.3253 2.87694 10.3253 5.0475V8.58228C9.23967 7.73061 7.87256 7.22222 6.38889 7.22222C4.90522 7.22222 3.53811 7.73061 2.4525 8.58233V5.0475ZM6.38889 18.8889C3.47872 18.8889 1.11111 16.5213 1.11111 13.6111C1.11111 10.7009 3.47872 8.33333 6.38889 8.33333C9.29906 8.33333 11.6667 10.7009 11.6667 13.6111C11.6667 16.5213 9.29906 18.8889 6.38889 18.8889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.38887 10.9336C5.49771 10.9336 4.77271 11.6586 4.77271 12.5498C4.77271 13.2458 5.21498 13.8405 5.83332 14.0675V15.7315H6.94443V14.0675C7.56271 13.8405 8.00504 13.2458 8.00504 12.5498C8.00504 11.6586 7.28004 10.9336 6.38887 10.9336ZM6.38887 13.0548C6.11037 13.0548 5.88382 12.8283 5.88382 12.5498C5.88382 12.2713 6.11037 12.0447 6.38887 12.0447C6.66737 12.0447 6.89393 12.2713 6.89393 12.5498C6.89393 12.8283 6.66737 13.0548 6.38887 13.0548Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.8bc31944998d157abd75cbc99107de27.svg";
export { ForwardRef as ReactComponent };